module.exports = __webpack_public_path__ + "assets/8512385c8360baca8927b94344733213.mp3";